import { Grid, List, ListItem, Theme, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Features, StageState } from '../../../types/type';

interface ConfirmationNextSteps {
  nextStep: string;
  stages: StageState[];
}
export default function ConfirmationNextSteps(props: ConfirmationNextSteps) {
  const theme: Theme = useTheme();
  const isEmergencyServiceAvailable = props.stages.some((element) => element.id === Features.EMERGENCY_SERVICES);
  const isWaterRemovalServiceAvailable = props.stages.some((element) => element.id === Features.WATER_REMOVAL);
  const isDocumentDamageServiceAvailable = props.stages.some((element) => element.id === Features.DOCUMENT_DAMAGE);
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ marginTop: '20px' }} variant="body1">
          Select <b>Continue to {props.nextStep}</b> and we'll guide you through:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List sx={theme.custom.styles.confirmationList}>
          {isEmergencyServiceAvailable && (
            <ListItem sx={theme.custom.styles.confirmationListElement}>
              <Typography variant="body1">Protecting your home by boarding up the damage</Typography>
            </ListItem>
          )}
          {isWaterRemovalServiceAvailable && (
            <ListItem sx={theme.custom.styles.confirmationListElement}>
              <Typography variant="body1">Emergency water removal assistance</Typography>
            </ListItem>
          )}
          {isDocumentDamageServiceAvailable && (
            <ListItem sx={theme.custom.styles.confirmationListElement}>
              <Typography variant="body1">Document your damage with Plnar Snap</Typography>
            </ListItem>
          )}
        </List>
      </Grid>
    </Grid>
  );
}
